export const getFileFromServer = (url: string) => {
  const baseUrl = process.env.REACT_APP_STORAGE_LINK;
  return url ? `${baseUrl}${url}` : '';
};
